import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/messages/Page";

export const PATH = "/messages";

const Home: NextPage = () => (
	<>
		<NskHead title="チャット" />
		<Component />
	</>
);

export default Home;
